import React, { useEffect, useState } from 'react'
import { FakeButtons } from './shared'
import { FormValues } from './types'
import { FormikConsumer, connect } from 'formik'

export const Debug = connect<{}, FormValues>(({ formik }) => {
  if (!formik.values._debug) return null

  return (
    <>
      <FakeButtons />
      <FormDebug />
      <JSErrors />
    </>
  )
})

const FormDebug: React.FC = () => {
  return (
    <details className="generic-admin-box for-platform-admins my-3">
      <summary>Form Debug</summary>
      <FormikConsumer>
        {({ validationSchema, validate, ...rest }) => <pre>{JSON.stringify(rest, null, 2)}</pre>}
      </FormikConsumer>
    </details>
  )
}

const JSErrors: React.FC = () => {
  const [errors, setErrors] = useState<ErrorEvent[] | []>([])

  useEffect(() => {
    const addError = (e: ErrorEvent) => setErrors([...errors, e])
    window.addEventListener('error', addError)
    return () => window.removeEventListener('error', addError)
  }, [setErrors, errors])

  return (
    <details className="generic-admin-box for-platform-admins my-3">
      <summary>JS Errors</summary>
      <table className="bpc-table bpc-table--striped">
        <tbody>
          {errors.map((e, i) => (
            <tr key={i}>
              <td>
                {/* eslint-disable-next-line @typescript-eslint/no-unsafe-member-access */}
                {e.error.name || <span>Error</span>}
                <span>:&nbsp;</span>
                {e.message}
              </td>
              <td>
                {e.filename}:{e.lineno}:{e.colno}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </details>
  )
}
